import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { router } from "./router/routes";
import { queryClient } from "./lib/query-client";
import { useThemeStore, applyThemeClass } from "./lib/stores/theme";
import { useBootstrapAuth } from "./features/auth/useMe";

function AuthBootstrap() {
  useBootstrapAuth();
  return null;
}

export function App() {
  const resolvedTheme = useThemeStore((s) => s.resolvedTheme);

  useEffect(() => {
    applyThemeClass(resolvedTheme);
  }, [resolvedTheme]);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthBootstrap />
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
